import styled from 'styled-components'

export const EmptyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  min-height: 400px;
  text-align: center;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: var(--sl-bg-base-soft);
  margin-bottom: 1.5rem;
  color: var(--sl-fg-base-soft);

  svg {
    opacity: 0.6;
  }
`

export const EmptyTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--sl-fg-base);
  margin: 0 0 0.5rem 0;
  line-height: 1.5;
`

export const EmptySubtitle = styled.p`
  font-size: 0.9375rem;
  color: var(--sl-fg-base-soft);
  margin: 0;
  max-width: 400px;
  line-height: 1.5;
`
